module.exports = __webpack_public_path__ + "12_hair_gold.d9b73443.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/12_hair_gold.png
// module id = X+0y
// module chunks = 0